export const regions = state => state.regions;
export const regionsAvailableToEngineers = state =>
  regionsLoadInProgress(state)
    ? null
    : state.regions.filter(region => region.enabled);
export const regionsAvailableToCities = state =>
  regionsLoadInProgress(state)
    ? null
    : state.regions.filter(region => region.enabled && !region.administrative);
export const regionsLoadInProgress = state => state.regions === null;

export const region = state => state.region;
export const isRegionLoading = state => state.region === null;



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/selectors/regions.js